import { LitElement, html, svg } from 'lit';

export class IconLandscape48 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="none" viewBox="0 0 48 48"><title>Sol og fjell</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19a6 6 0 1 0 0-12 6 6 0 0 0 0 12ZM43 41 32.092 23.201a2.685 2.685 0 0 0-2.202-1.2 2.675 2.675 0 0 0-2.23 1.15l-7.138 10.232-4.425-3.56a2.677 2.677 0 0 0-3.91.609L5 41"></path></svg>`; }
}
if (!customElements.get('f-icon-landscape48', IconLandscape48)) {
  customElements.define('f-icon-landscape48', IconLandscape48);
}